import { useEffect, useRef } from 'react';
import { useAccount, useWalletClient } from 'wagmi';
import { targetChainId } from '../../constant/constant';
import { useSwitchToTargetChain } from '../../hooks/useSwitchToTargetChain';

/**
 * After RainbowKit / wagmi connect, prompt add + switch when the wallet
 * is on another network (avoids needing a full page refresh).
 */
const PostConnectNetworkSetup = () => {
    const { isConnected, chainId } = useAccount();
    const { data: walletClient } = useWalletClient();
    const { switchToTargetChain } = useSwitchToTargetChain();
    const attemptRef = useRef(0);

    useEffect(() => {
        if (!isConnected || !walletClient) {
            attemptRef.current = 0;
            return;
        }

        if (Number(chainId) === Number(targetChainId)) {
            attemptRef.current = 0;
            return;
        }

        if (attemptRef.current > 0) return;

        const timer = setTimeout(() => {
            attemptRef.current += 1;
            switchToTargetChain().catch(() => {
                attemptRef.current = 0;
            });
        }, 400);

        return () => clearTimeout(timer);
    }, [isConnected, chainId, walletClient, switchToTargetChain]);

    return null;
};

export default PostConnectNetworkSetup;
